import React from 'react';
import EmptyList from 'src/components/templates/EmptyList.template';
const SelectListEmpty = ({ message }) => (React.createElement(EmptyList, { message: message }));
export default React.memo(SelectListEmpty);
